export default "__VITE_ASSET___8hLSctc__"